const NOTIFICATION_SOUND_MUTED_KEY = "fk_notification_sound_muted";

let audioContextInitialized = false;
let audioContext = null;

export const isNotificationSoundMuted = () => {
  try {
    return window.localStorage.getItem(NOTIFICATION_SOUND_MUTED_KEY) === "1";
  } catch {
    return false;
  }
};

export const setNotificationSoundMuted = (muted) => {
  try {
    if (muted) {
      window.localStorage.setItem(NOTIFICATION_SOUND_MUTED_KEY, "1");
    } else {
      window.localStorage.removeItem(NOTIFICATION_SOUND_MUTED_KEY);
    }
  } catch {
    /* ignore */
  }
};

const initializeAudioContext = () => {
  if (!audioContextInitialized) {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContextInitialized = true;
    } catch (error) {
      console.warn('AudioContext initialization failed:', error);
    }
  }
};

const resumeAudioContext = async () => {
  if (audioContext && audioContext.state === 'suspended') {
    try {
      await audioContext.resume();
    } catch (error) {
      console.warn('AudioContext resume failed:', error);
    }
  }
};

export const playNotificationSound = () => {
  if (isNotificationSoundMuted()) {
    return;
  }
  try {
    const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSmFyfPdeyYEK4TO8tiKOAcVY7zq6qNlEgxMpN/ytGcfCFCx6eywYxsHN4ne6qhkFRIceL7v2nIpBC2H0vRQdykGLYHM5qhrHBYoiML2nGwpBi2GzOamaxwYIo3Dzm9aJR8xjdXy3YYwChpUpr/zrW8gCjJ/xeO0aCMZJZXMv2VkHxkzeNLtqVsVFS2O0vZcdSsGKX3G7a5yKAwtjtT2YHgnBi2CzOaoaBsUKYjE9Z1sKQYthsrmqGscFyKOw85vWiUfMY3V8tyELgYdV63L8NKXPgkYTq7p6qlSGhIvgtT0VHUpBSx+xO2scygKMI7U9mB3KQYtgszmqGkcFCqIxPOdbCkGLYbM5qhrHRsjkMb0nm0pBSd9xOyucigKMI7U9mB3KQYtgszmqGscFCqJxPOdbCkGLYbM5qhrHRsjkMPznGwpBSd9xOyscigKMI3U9mJ2KgYogcXqrXAoBjGN1PZgdykGLYLM5qhpGxQqicTznWwpBi2GzOaoax0bI5DD85xsKQUnfcTsrnIoCjCN1PZidSoGKYHF6q1wKAYxjdT2YHcpBi2CzOaoaRsVKonE851sKQYthszmqWsdGyOQw/OcbCkFJ33E7K5yKAowjdT2YnUqBimBxeqtcCgGMY3U9mB3KQYtgszmqGkbFSqJxPOdbCkGLYbM5qlrHRsjkMPznGwpBSd9xOyucigKMI3U9mJ1KgYpgcXqrXAoBjGN1PZgdykGLYLM5qhpGxUqicTznWwpBi2GzOapax0bI5DD85xsKQUnfcTsrnIoCjCN1PZidSoGKYHF6q1wKAYxjdT2YHcpBi2CzOaoaRsVKonE851sKQYthszm==');
    audio.volume = 0.5;
    audio.play().catch(() => {
      try {
        const context = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = context.createOscillator();
        const gainNode = context.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(context.destination);

        oscillator.frequency.setValueAtTime(800, context.currentTime);
        oscillator.frequency.setValueAtTime(600, context.currentTime + 0.1);

        gainNode.gain.setValueAtTime(0.3, context.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, context.currentTime + 0.5);

        oscillator.start();
        oscillator.stop(context.currentTime + 0.5);
      } catch (audioError) {
        if ('vibrate' in navigator) {
          navigator.vibrate([200, 100, 200]);
        }
      }
    });
  } catch (error) {
    console.warn('Notification sound failed:', error);
  }
};

document.addEventListener('click', initializeAudioContext, { once: true });
document.addEventListener('keydown', initializeAudioContext, { once: true });